import { Component, OnInit } from '@angular/core';
import { MongoService } from 'src/app/services/mongo.service';
import { NavigatorService } from 'src/app/services/navigator.service';
import { StateService } from 'src/app/services/state.service';

@Component({
  selector: 'scoring-view',
  templateUrl: './scoring-view.component.html',
  styleUrl: './scoring-view.component.css'
})

export class ScoringViewComponent implements OnInit {

  scoresData: any[] = [];

  constructor(
    private navigator: NavigatorService,
    private mongoService: MongoService,
    private stateService: StateService
  ){}

  public async ngOnInit(): Promise<void> {
    
    if (this.stateService.getState() == 'state-pumps') {
      this.scoresData = await this.mongoService.getAllPumpsScoresData();
    } else if (this.stateService.getState() == 'state-airconditioners') {
      this.scoresData = await this.mongoService.getAllAirconditionersScoresData();
    }
  }

  public redirectToAdministrationScreen() : void {
    this.navigator.redirectToAdministrationScreen();
  }
}
